<template>
    <div class="text-center">
      <v-dialog v-model="dialog" persistent>
        <v-card>
          <v-card-title class="text-h5 blue lighten-0 darken-4 white--text">
            Crear un postgrado desde este proyecto:
          </v-card-title>
  
          <v-card-text> 
            Proyecto: {{ proy.programa_nombre }} {{ proy.codigos }}
            <posgrados v-on:select="vincular_id_posgrado" />

            <v-expansion-panels focusable>
              <v-expansion-panel >
                <v-expansion-panel-header>
                  <b class="purple--text">Crear nuevo posgrado</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="text-center mt-6 green--text">Complete la informacion faltante para crear el posgrado:</p>
                  <div class="row justify-center"> 
                    <div class="col-xs-12 col-sm-3 col-xl-1">
                      <v-text-field label="Creditaje:" v-model.number="input.creditaje"  type="number" prefix="creditos." hide-details />
                    </div>
                    <div class="col-xs-12 col-sm-3 col-xl-1">
                        <v-text-field label="Carga horaria:" v-model.number="input.carga_horaria"  type="number" prefix="horas." hide-details />
                    </div> 
                  </div> 
                  <div class="row justify-center">  
                    <div class="col-xs-12 col-sm-3 col-xl-1">
                        <v-text-field label="Duracion:" v-model.number="input.duracion"  type="number" :prefix="getunit" hide-details />
                    </div>
                    <div class="col-xs-12 col-sm-3 col-xl-1">
                        <v-select :items="unidades" item-value="id" v-model="input.unidad_duracion" label="Unidad de duracion" hide-details />
                    </div>
                  </div> 

                  <p class="text-center mb-0 mt-10 green--text">Indique si este proyecto estará disponible para incluirse en las listas de seleccion:</p>
                  <div class="row justify-center">
                    <div class="col-xs-12 col-sm-6">
                      <v-switch v-model="input2.version_para_oferta" color="green" :label="input2.version_para_oferta?'Esta version es para ofertar (autoria, libre oferta o alto rendimiento)':'Version no disponible para ofertar'"></v-switch>
                    </div>
                  </div>

                  <div class="text-center">
                    <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Crear nuevo posgrado </v-btn>         
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> 
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>   
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer> 
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 
      
    </div>
  </template>
  
  <script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import {mapArea,mapCategoria} from './utils.ts'
  import posgrados from './posgraditos/p-index.vue'
  import {get_proyecto_plantilla} from './posgraditos/get_proy.js'

  export default {
    components:{posgrados},
      data() {
        return {
          loading: true,
          dialog: false,
          proy: {},
          unidades: [
            {id:0, text:'Meses'},
            {id:1, text:'Semanas'},
            {id:2, text:'Dias'},
            {id:3, text:'Horas'},
          ],
          input:{
            creditaje:0,
            carga_horaria:0,
            duracion:0,
            unidad_duracion: 0
          }, 
          input2: {
            version_para_oferta: false
          }
        };
      },
      computed:{
        getunit(){
          let s = ''
            if(!this.input.unidad_duracion){
              s = this.unidades[0].text;
            }else{
              s = this.unidades[this.input.unidad_duracion].text
            }
            return s+': ';
        }
      },
      methods: {
        async openmodal(xproy) {
          window.console.log('xproycrear::',xproy);
          this.input2.version_para_oferta = false;
          this.input.creditaje = 0;
          this.input.carga_horaria = 0;
          this.input.duracion = 0;
          this.input.unidad_duracion = 0;
          
          this.proy = xproy;
          this.loading = false;
          this.dialog = true;  
          this.getplantilla_json()
                
        },
        cerrar() { 
            this.dialog = false;
        },
        async enviar(){
            let msg = '';
            if(!this.input.duracion) msg = 'Ingrese la duracion'
            if(!this.input.carga_horaria) msg = 'Ingrese la carga horaria'
            if(!this.input.creditaje) msg = 'Ingrese un creditaje'
            if(msg){
                this.$root.$notify.show(msg, {color:'red',x: 'right',});
                return;
            }

            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const data = {};
            data.idarea = mapArea(this.proy.area_universidad_id);
            data.idcategoria = mapCategoria(this.proy.categoria_universidad_id);
            data.nombre = this.proy.programa_nombre;
            data.portada = 'portadita.jpg';
            data.creditaje = parseInt(this.input.creditaje) || 0;
            data.duracion = parseInt(this.input.duracion) || 0;
            data.unidad_duracion = this.input.unidad_duracion;
            data.carga_horaria = parseInt(this.input.carga_horaria);
            data.unidad_negocio_id = unidad;
            // window.console.log('crear programa de: ', this.proy,data);

            this.loading = true;
            let sql = gql`mutation{ createPostgrado(input:${window.stringifyObject(data)}){ok,postgrado{id,nombre,unidad_duracion},errors{message}} }`;
            let res = await this.$apollo.mutate({  mutation: sql }).then(({ data }) => data).catch(e=>e);
            // window.console.log('res:::', res);
            if(res && res.createPostgrado && res.createPostgrado.ok){
                await this.vincular_id_posgrado(res.createPostgrado.postgrado.id,data.nombre)
            }

            this.loading = false;
        },

        async vincular_id_posgrado(posgrado_id, nombre){
          // let posgrado_id = res.createPostgrado.postgrado.id;
          // let posgrado_id = 3004;
          this.loading = true;
          let url = process.env.VUE_APP_URL_API_PAGOS2+'programa-universidad/'+this.proy.proyecto_id+'/update-posgrado-id'
              
          /*let resp = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ posgrado_id: posgrado_id })
          }).then(response => response.json()).then(data => data).catch(error => error);*/

          let resp = await xaxios.post(url,{ posgrado_id: posgrado_id }).then(d=>d).catch(e=>e);
          if(resp) resp = resp.data;
          window.console.log('resp',resp);
           
          const resp2 = await this.set_disponible_para_ofertar()
          this.loading = false;
          // window.console.log('rrrr:: ',r);
          
          // window.console.log('posssss',resp); 
          if(resp && resp.datos) {
            this.$emit('onsuccess',this.proy,resp,resp2);
            this.cerrar();
            this.$root.$notify.show('Posgrado vinculado: '+nombre, {color:'green',x: 'right',});
          }else {
            let m = '';
            if(resp && resp.errores){
              const data = resp.errores;
              const arraysDeCadenas = Object.values(data);
              const todasLasCadenas = arraysDeCadenas.flat();
              const cadenasFiltradas = todasLasCadenas.filter(elemento => typeof elemento === 'string');
              const cadenaConcatenada = cadenasFiltradas.join(', ');
              m = cadenaConcatenada;
            } 
            
            this.$root.$notify.show('Posgrado NO creado: '+m, {color:'red',x: 'right',});
            
          }
        },

        async set_disponible_para_ofertar(){
          let url = process.env.VUE_APP_URL_API_PAGOS2+'programa-universidad/vincular/update-disponible-para-oferta';
          
          const xin = { proyectoId: this.proy.proyecto_id,ofertar:this.input2.version_para_oferta };
          /*let resp = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(xin)
          }).then(response => response.json()).then(data => data).catch(error => error);*/

          let resp = await xaxios.post(url,xin).then(d=>d).catch(e=>e);
          window.console.log('resp',resp);

          return resp;
        },

        async getplantilla_json(){ 
          if(!this.proy && !this.proy.id) return;
          // const r = await get_proyecto_plantilla(this.proy.proyecto_id)
          const r = await get_proyecto_plantilla(350)
          if(r && r.proyecto_documento_libre){
            const d = r.proyecto_documento_libre
            const plantilla = JSON.parse(d.documento_proyecto_json)
            const xjson = plantilla.template_json
            const creditaje = xjson.find(x=>x.titulo=='CREDITAJE').contenido
            const horas = xjson.find(x=>x.titulo=='CARGA HORARIA').contenido
            const meses = xjson.find(x=>x.titulo=='DURACION EN MESES').contenido
            
            this.input.creditaje = creditaje
            this.input.carga_horaria = horas
            this.input.duracion = meses

            window.console.log('jejejejeje', plantilla)
            window.console.log('jejejejeje', creditaje)
            window.console.log('jejejejeje', horas)
            window.console.log('jejejejeje', meses)
          }
        }
      },
    };
  </script>
  